import React from "react";

import "./disclaimerTable.css";

const DisclaimerTable = ({ payFrequency }: { payFrequency?: "MONTHLY" | "WEEKLY" | "BIWEEKLY" }): JSX.Element => {
	return (
		<div className="disclaimer-table">
			<div className="table-heading">
				<div className="heading-coverage">Coverage</div>
				<div className="heading-premium">Premium Value</div>
			</div>
			{payFrequency === "WEEKLY" ? (
				<div className="table-details-container">
					<div className="table-details">
						<div className="coverage-details">Employee Only</div>
						<div className="premium-details">8.39% of Weekly Base Pay</div>
					</div>
					<div className="table-details">
						<div className="coverage-details">Coverage For Spouse</div>
						<div className="premium-details">$73.00 of Weekly Base Pay</div>
					</div>
					<div className="table-details">
						<div className="coverage-details">Coverage For One Child</div>
						<div className="premium-details">$32.00 of Weekly Base Pay</div>
					</div>
					<div className="table-details">
						<div className="coverage-details">Coverage For Two or More Child</div>
						<div className="premium-details">$64.00 of Weekly Base Pay</div>
					</div>
				</div>
			) : payFrequency === "MONTHLY" ? (
				<div className="table-details-container">
					<div className="table-details">
						<div className="coverage-details">Employee Only</div>
						<div className="premium-details">8.39% of Monthly Base Pay</div>
					</div>
					<div className="table-details">
						<div className="coverage-details">Coverage For Spouse</div>
						<div className="premium-details">$316.33 of Monthly Base Pay</div>
					</div>
					<div className="table-details">
						<div className="coverage-details">Coverage For One Child</div>
						<div className="premium-details">$138.67 of Monthly Base Pay</div>
					</div>
					<div className="table-details">
						<div className="coverage-details">Coverage For Two or More Child</div>
						<div className="premium-details">$277.33 of Monthly Base Pay</div>
					</div>
				</div>
			) : null}
		</div>
	);
};

export default DisclaimerTable;
